import { useState } from "react";
import ReactDOM from "react-dom";
import "./contact.css"; // Optional: For adding styles
import { Col, Row } from "reactstrap";
import logo from "../../../Assets/image/SEA_Logo_White_Text2.png";
import Bar1 from "../../../components/navigationbar/navigationbar1";

const ContactUs = () => {
    const [showPopup, setShowPopup] = useState(false);
    return (
        <>
            <div className="containercon ">
                <div className="containercon1">

                    <div >
                        <div className="map-container" style={{ position: "relative", width: "100%", height: "270px" }}>
                            {/* Google Map */}
                            <iframe
                                src="https://maps.google.com/maps?q=sandip%20electronics %20and%20automation%20&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed"
                                frameBorder="0"
                                scrolling="no"
                                style={{
                                    width: "100%",
                                    height: "270px",
                                    border: "none",
                                    position: "relative",
                                    zIndex: 1,
                                }}
                                allowFullScreen
                            ></iframe>

                            {/* Invisible Hover Area for Marker */}
                            <div
                                className="hover-area"
                                onMouseEnter={() => setShowPopup(true)}
                                onMouseLeave={() => setShowPopup(false)}
                                style={{
                                    position: "absolute",
                                    top: "60%", // Adjust this to match the marker position
                                    left: "50%", // Adjust this to match the marker position
                                    transform: "translate(-50%, -50%)",
                                    width: "35px",
                                    height: "35px",
                                    cursor: "pointer",
                                    backgroundColor: "transparent", // Light red transparent for debugging, remove later
                                    zIndex: 2,
                                }}
                            ></div>

                            {/* Popup Content (Only when hovering over the exact location) */}
                            {showPopup && (
                                <div className="popup-content">
                                    <h3>Sandip electronics & Automation</h3>
                                    <p>electronics  Solutions Provider</p>
                                    <p>Location: XYZ Street, City, Country</p>
                                </div>
                            )}

                            <style jsx>{`
        .popup-content {
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translateX(-50%);
          background: white;
          padding: 10px;
          border-radius: 5px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
          z-index: 3;
          text-align: center;
          transition: opacity 1s ease-in-out;
        }
      `}</style>
                        </div>

                    </div>

                    <div className="myshadow"></div>

                    <div className="contactdeta">
                        <div className="sealogo">
                            <img src={logo} alt="Logo" style={{ height: '80px', width: '180px', }} />
                        </div>
                        {/* <div className="condetails">

                            <div className="col1">
                                <div className="condetails1">
                                    <p><b> Email </b> support@seaiot.in </p>
                                    <p><b> Mob No</b> <br/>(+91) 9765214501 <br /> <p>(+91) 8275451140</p> </p>
                                </div>
                                <div className="condetails2">
                                    <b>Address</b>
                                    Register Office 567, Kute Wasti, Nagar Road, Near Ganpati Temple, Sukewadi,
                                    Tal. Sangamner, Dist.  Ahmednagar Sangamner-422605.<br />
                                    <b>Work</b>
                                    hop No. 12, 78/1, Aura Industrial Cluster, Near Hindustan Bakery, Shivne, Pune-411023
                                    sandip electronics  And Automation
                                    <p style={{ fontSize: '25px', color: '#00F2E6' }}>
                                        sandip electronics  And Automation
                                    </p>
                                </div>
                            </div>


                            <div className="col2">
                                <p><b>GSTIN NO </b> 27CEXPK0954C1Z9</p>
                                <p><b>PAN NO</b> CEXPK0954C</p>
                            </div>
                        </div> */}
                        <div>

                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default ContactUs;

